<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Title"
              aria-label="Title"
              aria-describedby="Title"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getArticles(1)">Search</button>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-1 text-right">
          <base-button type="primary" size="md" @click="openModal()">Create New</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="articles"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Title</th>
          <th class="text-center">Role</th>
          <th class="text-center">Updated Date</th>
          <th class="text-center">Status</th>
          <th class="text-center"></th>
          <th class="text-center"></th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.title}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.role_name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <!-- <span class="name mb-0 text-sm" v-if="row.recommended === '1'">Yes</span> -->
                <!-- <i class="ni ni-check-bold" v-if="row.recommended === '1'"></i>
                <i class="ni ni-fat-remove" v-if="row.recommended === '0'"></i>-->

                <span class="name mb-0 text-sm">{{row.last_updated}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-muted" v-if="row.status == '0'">Draft</span>
                <span class="name mb-0 text-sm text-success" v-if="row.status == '1'">Published</span>
                <span class="name mb-0 text-sm text-danger" v-if="row.status == '2'">Unpublished</span>
              </div>
            </div>
          </td>

          <td class="text-right" @click="toggleClass()">
            <base-dropdown class="dropdown" position="right">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" target="_blank" :href="row.public_article_url">View</a>
                <a class="dropdown-item" @click="getArticle(row.news_id)">Update</a>
                <a class="dropdown-item" @click="deleteArticle(row.news_id)">Delete</a>
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>

    <div class="row" id="div-create_package_modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.create_article_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">CREATE ARTICLE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Role:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <select class="browser-default custom-select" v-model="createArticle.role">
                        <option value>-- Select Role --</option>
                        <option value="1">Candidate</option>
                        <option value="2">Employer</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Status:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <select class="browser-default custom-select" v-model="createArticle.status">
                        <option value>-- Select Status --</option>
                        <option value="0">Draft</option>
                        <option value="1">Published</option>
                        <option value="1">Not Published</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Title:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <base-input
                        alternative
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="createArticle.title"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Short Description:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        id="short_description"
                        rows="3"
                        placeholder="Short Description"
                        v-model="createArticle.shortDescription"
                      ></textarea>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Image:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <!-- <base-input alternative=""
                                                placeholder="Credit"
                                                input-classes="form-control-alternative"
                                                type="number"
                      />-->
                      <!-- <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
                                      </div>
                                      <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="inputGroupFile01"
                                          aria-describedby="inputGroupFileAddon01" @change="uploadFile($event)">
                                        <label class="custom-file-label" for="inputGroupFile01" v-if="createArticle.fileName == ''">Choose file</label>
                                        <label class="custom-file-label" for="inputGroupFile01" v-if="createArticle.fileName != ''">{{createArticle.fileName}}</label>
                                      </div>
                      </div>-->
                      <div class="custom-file-container" data-upload-id="imageUpload">
                        <label>
                          <a
                            href="javascript:void(0)"
                            class="custom-file-container__image-clear"
                            title="Clear Image"
                          ></a>
                        </label>
                        <label class="custom-file-container__custom-file">
                          <input
                            type="file"
                            class="custom-file-container__custom-file__custom-file-input"
                            accept="*"
                            aria-label="Choose File"
                            @change="uploadFile($event)"
                          />
                          <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                          <span
                            class="custom-file-container__custom-file__custom-file-control custom-file-label"
                          ></span>
                        </label>
                        <div class="custom-file-container__image-preview"></div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3">
                      Html:
                      <span class="text-danger"></span>
                    </label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control summernote"
                        id="summernote"
                        ref="summernote"
                        :model="createArticle.html"
                      ></textarea>
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.create_article_modal = false"
                    >Cancel</base-button>
                    <base-button type="success" class="my-4" @click="createArticles()">Create</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div class="row" id="div-update-package-modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.update_article_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">UPDATE ARTICLE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Role:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <select class="browser-default custom-select" v-model="updateArticle.role">
                        <option value>-- Select Role --</option>
                        <option value="1" :selected="updateArticle.row == 1">Candidate</option>
                        <option value="2" :selected="updateArticle.row == 2">Employer</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Title:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <base-input
                        alternative
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="updateArticle.title"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Status:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <select class="browser-default custom-select" v-model="updateArticle.status">
                        <option value>-- Select Status --</option>
                        <option value="0">Draft</option>
                        <option value="1">Published</option>
                        <option value="2">Not Published</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Short Description:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        id="short_description"
                        rows="3"
                        placeholder="Short Description"
                        v-model="updateArticle.shortDescription"
                      ></textarea>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Image:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <!-- <base-input alternative=""
                                                placeholder="Credit"
                                                input-classes="form-control-alternative"
                                                type="number"
                      />-->
                      <!-- <div class="input-group">
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
                                      </div>
                                      <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="inputGroupFile01"
                                          aria-describedby="inputGroupFileAddon01" @change="uploadFile($event)">
                                        <label class="custom-file-label" for="inputGroupFile01" v-if="updateArticle.fileName == ''">Choose file</label>
                                        <label class="custom-file-label" for="inputGroupFile01" v-if="updateArticle.fileName != ''">{{updateArticle.fileName}}</label>
                                      </div>
                      </div>-->
                      <div class="custom-file-container" data-upload-id="updateImageUpload">
                        <label>
                          <a
                            href="javascript:void(0)"
                            class="custom-file-container__image-clear"
                            title="Clear Image"
                          ></a>
                        </label>
                        <label class="custom-file-container__custom-file">
                          <input
                            type="file"
                            class="custom-file-container__custom-file__custom-file-input"
                            accept="*"
                            aria-label="Choose File"
                            @change="uploadFile($event)"
                          />
                          <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                          <span
                            class="custom-file-container__custom-file__custom-file-control custom-file-label"
                          ></span>
                        </label>
                        <div class="custom-file-container__image-preview"></div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3">
                      Html:
                      <span class="text-danger"></span>
                    </label>
                    <div class="col-sm-9">
                      <textarea
                        class="form-control summernote"
                        id="updateArticleHtml"
                        ref="summernote"
                      ></textarea>
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.update_article_modal = false;"
                    >Cancel</base-button>
                    <base-button type="success" class="my-4" @click="updateArticles()">Update</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalArticles" :value="parseInt(pageNumber)"></base-pagination>
      <!-- <div class="row"> -->
      <!-- <div class="col-10"></div>
      <div class="col-2"><base-pagination :perPage="5" :total="creditPackages.length"></base-pagination></div>-->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import FileUploadWithPreview from "file-upload-with-preview";
import EventBus from "./../../event-bus";
import "file-upload-with-preview/dist/file-upload-with-preview.min.css";

export default {
  name: "articles-table",
  props: {
    type: {
      type: String
    },
    title: String,
    status: String
  },
  data() {
    return {
      search_text: "",
      totalArticle: 0,
      show: false,
      message: "",
      createArticle: {
        role: "",
        title: "",
        shortDescription: "",
        image: "",
        html: "",
        fileName: "",
        status: ""
      },
      updateArticle: {
        newsId: 0,
        role: "",
        title: "",
        shortDescription: "",
        image: "",
        html: "",
        fileName: "",
        status: ""
      },
      modals: {
        create_article_modal: false,
        update_article_modal: false
      }
    };
  },
  computed: {
    articles() {
      return this.$store.getters.articles;
    },
    pageNumber() {
      return this.$route.query.page;
    },
    totalArticles() {
      return this.totalArticle;
    }
  },
  watch: {
    pageNumber() {
      this.getArticles(this.$route.query.page);
    },

    status: function() {
      this.getArticles(this.$route.query.page);
      this.getTotalArticles();
    }
  },
  mounted() {
    this.getArticles(1);
    this.getTotalArticles();
  },
  methods: {
    toggleClass: function() {
      // alert($(".dropdown-menu").hasClass("show"));
      // if($(".dropdown-menu").hasClass("show")){
      //     $('.table-responsive').css("overflow", "inherit");
      //  } else {
      //     $('.table-responsive').css("overflow", "auto");
      //  }
    },

    getArticles: function(page_number) {
      this.$store
        .dispatch("fetchArticles", { keyword: this.search_text, page: page_number, status: this.status })
        .then(response => {
          const { data, meta } = response.data;
          this.totalArticle = meta.total_result;
          this.$router.push({ query: { page: page_number } });
          this.$store.dispatch("updateState", {
            key: "articles",
            value: data
          });
        });
    },

    getTotalArticles() {
      this.$store
        .dispatch("fetchTotalArticles", {
          status: this.status
        })
        .then(response => {
          this.totalArticle = response.data.total;
        });
    },

    createArticles() {
      this.$store
        .dispatch("createArticle", {
          role: this.createArticle.role,
          title: this.createArticle.title,
          short_description: this.createArticle.shortDescription,
          image: this.createArticle.fileName,
          html: $("#summernote").val(),
          status: this.createArticle.status
        })
        .then(response => {
          if (response.data.error == "1000") {
            var page = this.$route.query.page;
            if ((this.totalArticles % 10) === 0) {
              page++;
            }
            this.modals.create_article_modal = false;
            this.getArticles(page);
            this.getTotalArticles();
            EventBus.$emit("getTotalArticles");
            EventBus.$emit("getTotalPublishedArticles");
            EventBus.$emit("getTotalUnpublishedArticles");
            EventBus.$emit("getTotalDraftArticles");
          } else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    getArticle(article_id) {
      var upload;
      this.show = false;
      this.message = "";
      this.$store
        .dispatch("fetchArticle", {
          news_id: article_id
        })
        .then(response => {
          this.modals.update_article_modal = true;

          $("#updateArticleHtml").summernote({
            placeholder: "",
            tabsize: 2,
            height: 500
          });

          let responseData = response.data;
          this.updateArticle.newsId = article_id;
          this.updateArticle.role = responseData.role;
          this.updateArticle.title = responseData.title;
          this.updateArticle.shortDescription = responseData.short_description;
          this.updateArticle.image = responseData.image;
          this.updateArticle.fileName = this.getFileName(responseData.image);
          this.updateArticle.html = responseData.html;
          this.updateArticle.status = responseData.status;

          $(".note-editable").html(responseData.html);

          if (responseData.image === "") {
            upload = new FileUploadWithPreview("updateImageUpload");
          } else {
            upload = new FileUploadWithPreview("updateImageUpload", {
              presetFiles: [responseData.image]
            });
          }
        });
    },

    updateArticles() {
      this.$store
        .dispatch("updateArticle", {
          news_id: this.updateArticle.newsId,
          role: this.updateArticle.role,
          title: this.updateArticle.title,
          image: this.updateArticle.fileName,
          html: $("#updateArticleHtml").summernote("code"),
          short_description: this.updateArticle.shortDescription,
          status: this.updateArticle.status
        })
        .then(response => {
          if (response.data.error == "1000") {
            this.modals.update_article_modal = false;
            this.getArticles(this.$route.query.page);
            this.getTotalArticles();
            EventBus.$emit("getTotalArticles");
            EventBus.$emit("getTotalPublishedArticles");
            EventBus.$emit("getTotalUnpublishedArticles");
            EventBus.$emit("getTotalDraftArticles");
          } else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        });
    },

    deleteArticle(article_id) {
      var result = confirm('Are you sure want to delete?');
      if(result)
      {
        this.$store
          .dispatch("deleteArticle", {
            id: article_id
          })
          .then(response => {
            var page = this.$route.query.page;
            if ((this.totalArticles % 10) === 1) {
              page--;
            }
            this.getArticles(page);
            this.getTotalArticles();
            EventBus.$emit("getTotalArticles");
            EventBus.$emit("getTotalPublishedArticles");
            EventBus.$emit("getTotalUnpublishedArticles");
            EventBus.$emit("getTotalDraftArticles");
          })
          .catch(error => {
              console.log(error.message);
          });
      }
    },

    openModal() {
      this.show = false;
      this.message = "";
      this.createArticle.role = "";
      this.createArticle.title = "";
      this.createArticle.shortDescription = "";
      this.createArticle.image = "";
      this.createArticle.html = "";
      this.createArticle.fileName = "";
      this.createArticle.status = "";
      var upload = new FileUploadWithPreview("imageUpload");
      $("#summernote").summernote({
        placeholder: "",
        tabsize: 2,
        height: 500
      });
      $("#summernote").summernote("reset");
      this.modals.create_article_modal = true;
    },

    uploadFile: function(event) {
      let formData = new FormData();
      formData.append("file", event.target.files[0]);

      this.$store.dispatch("uploadArticleFile", formData).then(response => {
        const { file_name, url } = response.data;
        this.createArticle.image = url;
        this.createArticle.fileName = file_name;
        this.updateArticle.image = url;
        this.updateArticle.fileName = file_name;
      });
    },

    getFileName: function(image) {
      var filename = image.split('/').pop();
      return filename.split('?')[0];
    }
  }
};
</script>
<style>
.custom-file-container__custom-file__custom-file-control {
  color: #8898aa;
  border-color: #cad1d7;
}

.custom-file-container__custom-file__custom-file-control__button {
  color: #8898aa;
}
</style>
